const fr = {
  nav: {
    home: 'Accueil',
    about: 'À propos',
    solutions: 'Solutions',
    industries: 'Secteurs',
    contact: 'Contact',
  },

  home: {
    phases: [
      {
        h1Before: 'Solutions ',
        h1Highlight: 'IT',
        h1After: ' sur mesure',
        h3: 'qui évoluent avec votre entreprise',
        cols: [
          { border: 'l-blue', lines: ['Présence', 'Digitale'] },
          { border: 'l-cyan', lines: ['Ingénierie', 'Applicative'] },
          { border: 'l-pink', lines: ['Intégration', 'Enterprise'] },
        ],
      },
      {
        h1Before: 'Notre ',
        h1Highlight: 'Proposition',
        h1After: ' de Valeur',
        h3: 'qui évoluent avec votre entreprise',
        cols: [
          { border: 'l-blue', lines: ['Optimisation', 'des Processus'] },
          { border: 'l-cyan', lines: ['Transformation', 'Digitale'] },
          { border: 'l-pink', lines: ['Décisions', 'Data-Driven'] },
        ],
      },
      {
        h1Before: 'Alignement ',
        h1Highlight: 'Stratégique',
        h1After: ' d\'Entreprise',
        h3: 'qui évoluent avec votre entreprise',
        cols: [
          { border: 'l-blue', lines: ['Clarté', 'Stratégique'] },
          { border: 'l-cyan', lines: ['Exécution', 'Experte'] },
          { border: 'l-pink', lines: ['Partenariat', 'Durable'] },
        ],
      },
    ],
  },

  about: {
    slides: [
      {
        tag: 'À propos',
        accent: 'var(--violet)',
        titleBefore: 'À ',
        titleHighlight: 'propos',
        subtitle: 'Fondés en 2018 et basés à Goslar, Allemagne — avec des équipes de développement en Allemagne et en Inde.',
        body: 'Conçus pour les PME et les initiatives sociales, nous utilisons la technologie comme catalyseur d\'une croissance durable — comblant le fossé entre les grandes idées et les solutions digitales qui les concrétisent.',
        features: [
          { label: 'Fondés à Goslar, Allemagne — 2018' },
          { label: 'Équipes en Allemagne & Inde' },
          { label: 'Pour les PME & Initiatives Sociales' },
        ],
        quoteBefore: 'Nous comblons le fossé d\'exécution digitale grâce au Proxy Product Ownership, en traduisant des exigences métier complexes en solutions digitales fiables, évolutives et haute performance.',
        quoteAuthor: 'Alignement Stratégique',
      },
      {
        tag: 'À propos',
        accent: 'var(--cyan)',
        titleBefore: 'Notre ',
        titleHighlight: 'Vision',
        subtitle: 'Donner aux PME les moyens de la Transformation Digitale et de l\'Innovation.',
        body: 'Chez 7elemente, nous envisageons un avenir où les petites et moyennes entreprises atteignent leur plein potentiel en alignant les capacités digitales avec la clarté stratégique. Notre objectif est de permettre aux PME d\'opérer à leur capacité optimale.',
        features: [
          { label: 'Inspirer' },
          { label: 'Innover' },
          { label: 'Impact' },
        ],
        quoteBefore: 'La prochaine génération de leaders du marché ne sera pas définie par la taille — elle sera définie par la façon dont ils utilisent la technologie.',
        quoteAuthor: 'Notre Vision',
      },
      {
        tag: 'À propos',
        accent: 'var(--highlight)',
        titleBefore: 'Notre ',
        titleHighlight: 'Mission',
        subtitle: 'Co-créer des solutions évolutives.',
        body: 'Nous co-créons des solutions digitales qui grandissent avec nos clients — évoluant avec leur capacité, alignées sur leurs ambitions et ancrées dans la valeur à long terme. Grâce à un design réfléchi, des systèmes intelligents et un partenariat stratégique, nous assurons un impact durable.',
        features: [
          { label: 'Clarté Stratégique' },
          { label: 'Exécution Experte' },
          { label: 'Partenaire de Confiance' },
        ],
        quoteBefore: 'Vous vous concentrez sur vos objectifs — nous serons votre bras IT.',
        quoteAuthor: 'Notre Mission',
      },
    ],
  },

  solutions: {
    slides: [
      {
        tag: 'Solution',
        accent: 'var(--violet)',
        video: 'digexp',
        titleBefore: 'Présence ',
        titleHighlight: 'Digitale',
        subtitle: 'Votre présence en ligne n\'est pas seulement un site web — c\'est votre poignée de main digitale.',
        body: 'Nous créons des expériences digitales fluides qui mêlent design, technologie et performance. Des sites web visuellement époustouflants aux plateformes optimisées, nous vous aidons à gagner en visibilité, stimuler l\'engagement et croître avec intention.',
        features: [
          { label: 'Web Design Responsive' },
          { label: 'SEO & Performance' },
          { label: 'Transformation Digitale' },
        ],
        quoteBefore: 'Votre site web est votre meilleur commercial — disponible 24h/24, accessible à tous, partout.',
        quoteAuthor: 'Digital First',
      },
      {
        tag: 'Solution',
        accent: 'var(--cyan)',
        video: 'appeng',
        titleBefore: 'Ingénierie des ',
        titleHighlight: 'Applications',
        subtitle: 'Des interfaces aux systèmes backend enterprise — nous développons tout.',
        body: 'Des startups aux produits en croissance et à la modernisation des systèmes hérités, nous transformons les idées en puissants produits digitaux — alliant design réfléchi et technologie évolutive et fluide.',
        features: [
          { label: 'Applications Web Personnalisées' },
          { label: 'Développement d\'Applications Mobiles' },
          { label: 'Automatisation des Workflows' },
        ],
        quoteBefore: 'Un bon logiciel ne consiste pas à écrire du code — il s\'agit de résoudre les bons problèmes de la façon la plus simple possible.',
        quoteAuthor: 'Philosophie d\'Ingénierie',
      },
      {
        tag: 'Solution',
        accent: 'var(--highlight)',
        video: 'entint',
        titleBefore: 'Intelligence ',
        titleHighlight: 'Enterprise',
        subtitle: 'De la stratégie au cloud, des données aux processus — nous aidons les entreprises à évoluer.',
        body: 'Chez 7element, nous aidons les entreprises du retail et de la production à rationaliser leurs opérations, unifier les expériences digitales et physiques, et évoluer avec confiance. Du commerce connecté à l\'intégration ERP et PIM.',
        features: [
          { label: 'Solutions PIM' },
          { label: 'Infrastructure Cloud' },
          { label: 'Intégration de Systèmes' },
        ],
        quoteBefore: 'L\'intégration n\'est pas un défi technique — c\'est un défi stratégique. Des systèmes connectés créent des organisations connectées.',
        quoteAuthor: 'Stratégie Enterprise',
      },
    ],
  },

  industries: {
    slides: [
      {
        tag: 'Secteur',
        accent: 'var(--violet)',
        video: 'manufacturing',
        title: 'Retail & Production',
        subtitle: 'Digitaliser les parcours retail et moderniser les processus de production.',
        body: 'Chez 7element, nous aidons les entreprises du retail et de la production à rationaliser leurs opérations, unifier les expériences digitales et physiques, et évoluer avec confiance. Du commerce connecté à l\'intégration ERP et PIM.',
        features: [
          { label: 'Gestion des Informations Produit (PIM)' },
          { label: 'E-Commerce & Présence en Ligne' },
          { label: 'Opérations & Intégration Supply Chain' },
        ],
        quoteBefore: 'Les systèmes déconnectés créent des expériences déconnectées. Nous unifions tout — intelligemment, fluidement et à grande échelle.',
        quoteAuthor: 'Retail & Production',
      },
      {
        tag: 'Secteur',
        accent: 'var(--cyan)',
        video: 'education',
        title: 'Éducation & Formation',
        subtitle: 'Renforcer l\'apprentissage grâce à l\'innovation digitale.',
        body: 'Dans un paysage éducatif en évolution, la transformation digitale améliore l\'apprentissage, optimise l\'administration et élargit l\'accès. Nous aidons les institutions à offrir des expériences d\'apprentissage personnalisées, évolutives et engageantes.',
        features: [
          { label: 'Développement de Plateformes E-Learning' },
          { label: 'Gestion de Contenus et de Cours' },
          { label: 'Ingénierie d\'Applications EdTech' },
        ],
        quoteBefore: 'L\'éducation évolue, et ses outils devraient en faire autant. Adopter la transformation digitale n\'est pas une option — c\'est une nécessité pour un apprentissage tourné vers l\'avenir.',
        quoteAuthor: 'Éducation & Formation',
      },
      {
        tag: 'Secteur',
        accent: 'var(--highlight)',
        video: 'dna',
        title: 'Santé & Bien-être',
        subtitle: 'Solutions de santé digitale sécurisées, connectées et centrées sur l\'humain.',
        body: 'La transformation digitale remodèle la santé en améliorant les soins aux patients, en optimisant les opérations et en garantissant la conformité. Nous construisons des systèmes sécurisés et évolutifs permettant des expériences de soins personnalisées.',
        features: [
          { label: 'Applications Web pour Patients' },
          { label: 'Gestion des Données conforme au RGPD' },
          { label: 'Automatisation des Réservations & Workflows' },
        ],
        quoteBefore: 'En santé, chaque donnée représente une vie. Assurer un flux d\'informations fluide, sécurisé et accessible n\'est pas qu\'une nécessité technique — c\'est un impératif moral.',
        quoteAuthor: 'Santé & Bien-être',
      },
    ],
  },

  contact: {
    navContact: 'Contact',
    navImpression: 'Mentions Légales',
    tag: 'Prenons Contact',
    heading: 'Contact',
    headingHighlight: '',
    intro: 'Que vous partiez de zéro ou que vous cherchiez à évoluer, nous aimerions connaître vos objectifs. Contactez-nous et l\'un de nos experts vous répondra dans les 24 heures.',
    addressLabel: 'Adresse',
    emailLabel: 'Email',
    phoneLabel: 'Téléphone',
    form: {
      namePlaceholder: 'Votre nom',
      emailPlaceholder: 'votre@email.com',
      companyPlaceholder: 'Nom de votre entreprise',
      messagePlaceholder: 'Parlez-nous de votre projet...',
      nameLabel: 'Nom',
      emailLabel: 'Email',
      companyLabel: 'Entreprise',
      messageLabel: 'Message',
      submit: 'Envoyer le Message',
      sending: 'Envoi en cours…',
    },
    successHeading: 'Message envoyé !',
    successBody: 'Nous vous répondrons dans les 24 heures.',
    errorMsg: 'Une erreur s\'est produite. Veuillez réessayer ou nous écrire directement.',
    impression: {
      tag: 'Légal',
      titleBefore: 'Mentions ',
      titleHighlight: 'Légales',
      subtitle: '7Elemente IT-Solutions UG (haftungsbeschränkt)',
      body: 'Conformément au § 5 TMG (Telemediengesetz). Ce site est exploité par 7Elemente IT-Solutions UG. Tous les contenus sont soumis au droit d\'auteur allemand.',
      features: [
        { label: 'Bahnhofstraße 11, 38642 Goslar, Allemagne' },
        { label: 'Email : info@7Elemente.com' },
        { label: 'Téléphone : +49 5321 39 49 49 6' },
        { label: 'Registre : Amtsgericht Braunschweig' },
      ],
      quoteBefore: 'La transparence n\'est pas seulement une obligation légale — elle reflète la façon dont nous faisons des affaires.',
      quoteAuthor: 'Mentions Légales',
    },
  },

  mitra: {
    slides: [
      {
        letter: 'M',
        tag: 'Nos Valeurs',
        titleBefore: '',
        titleHighlight: 'Maîtrise',
        subtitle: '15+ ans d\'excellence IT enterprise.',
        body: 'Nous apportons une expertise approfondie en SAP, Microsoft Dynamics, infrastructure cloud et développement web moderne — acquise à travers des projets enterprise réels, pas la théorie.',
        features: [
          { label: 'Architecture Enterprise' },
          { label: 'Expertise Cross-Domain' },
          { label: 'Livraison Éprouvée' },
        ],
        accent: 'var(--violet)',
        quote: 'L\'excellence n\'est pas une compétence — c\'est une habitude construite au fil des années à résoudre les problèmes que les autres ne pouvaient pas.',
      },
      {
        letter: 'I',
        tag: 'Nos Valeurs',
        titleBefore: '',
        titleHighlight: 'Intégrité',
        subtitle: 'Une livraison transparente, à chaque étape.',
        body: 'Nous croyons en une communication honnête, des délais réalistes et sans coûts cachés. Nos clients savent toujours où en est leur projet — et pourquoi.',
        features: [
          { label: 'Tarification Transparente' },
          { label: 'Délais Honnêtes' },
          { label: 'Communication Claire' },
        ],
        accent: 'var(--cyan)',
        quote: 'Le fondement de tout grand partenariat est la confiance — et la confiance se construit par la transparence.',
      },
      {
        letter: 'T',
        tag: 'Nos Valeurs',
        titleBefore: '',
        titleHighlight: 'Talent',
        subtitle: 'Un réseau sélectionné de professionnels experts.',
        body: 'Nous sélectionnons des spécialistes de notre réseau d\'ingénieurs senior, designers et stratèges — constituant la bonne équipe pour chaque défi unique.',
        features: [
          { label: 'Réseau Senior Uniquement' },
          { label: 'Spécialistes de Domaine' },
          { label: 'Équipes Agiles' },
        ],
        accent: 'var(--highlight)',
        quote: 'Les grands produits ne sont pas construits par de grandes entreprises — ils sont construits par de grandes personnes.',
      },
      {
        letter: 'R',
        tag: 'Nos Valeurs',
        titleBefore: '',
        titleHighlight: 'Fiabilité',
        subtitle: 'Dans les délais, dans le budget — à chaque fois.',
        body: 'Nous fixons des attentes réalistes et les tenons. Notre approche structurée de la gestion de projet garantit une qualité constante du lancement à la livraison.',
        features: [
          { label: 'Livraison par Jalons' },
          { label: 'Assurance Qualité' },
          { label: 'Support Post-Lancement' },
        ],
        accent: 'var(--violet)',
        quote: 'La fiabilité ne consiste pas à être parfait — il s\'agit d\'être fiable quand cela compte le plus.',
      },
      {
        letter: 'A',
        tag: 'Nos Valeurs',
        titleBefore: '',
        titleHighlight: 'Adaptabilité',
        subtitle: 'Agile, pérenne et en constante évolution.',
        body: 'La technologie évolue rapidement. Nous restons à la pointe — adoptant de nouveaux outils, frameworks et méthodologies pour garantir que vos solutions restent compétitives pendant des années.',
        features: [
          { label: 'Méthodologie Agile' },
          { label: 'Architecture Pérenne' },
          { label: 'Innovation Continue' },
        ],
        accent: 'var(--cyan)',
        quote: 'Les entreprises qui prospèrent ne sont pas les plus fortes — ce sont celles qui répondent le mieux au changement.',
      },
    ],
  },
};

export default fr;
